var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.37065V26.6202C0 27.3343 0.665753 28 1.37996 28H26.6333C27.0186 28 27.3892 27.7797 27.5814 27.5681C27.6617 27.4797 27.797 27.2696 27.8489 27.1458C28.1244 26.4895 28.0212 25.9859 27.5503 25.4964C27.267 25.2019 26.9777 25.0335 26.4263 25.0335H2.96694V1.57763C2.96694 -0.539785 0 -0.370777 0 1.37065H0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5283 1.57762V20.6873C23.5283 21.4376 24.1956 22.136 25.0463 22.136C25.7831 22.136 26.4952 21.488 26.4952 20.7563V1.37064C26.4952 0.616197 25.6996 -0.0692749 24.9247 0.00561797C24.1639 0.0791572 23.5283 0.700243 23.5283 1.57762L23.5283 1.57762Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7295 6.1998V20.4803C11.7295 22.6758 14.7654 22.6758 14.7654 20.4803V6.1998C14.7654 3.83111 11.7295 3.83111 11.7295 6.1998Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6636 8.75235V20.7562C17.6636 22.6039 20.6305 22.5282 20.6305 20.6872V8.82132C20.6305 6.98041 17.6636 6.90466 17.6636 8.75235Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.86475 13.2366V20.6873C5.86475 21.4377 6.53199 22.1361 7.38271 22.1361C8.11956 22.1361 8.83166 21.4881 8.83166 20.7563V13.1676C8.83166 11.3199 5.86475 11.3957 5.86475 13.2366Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.bb2ac4ad22b003ee718345f252731278.svg";
export { ForwardRef as ReactComponent };